import React, { ForwardedRef } from "react";
import clsx from "clsx";

import ArrowDownCircleIcon from "@tiny/icons/generated/ChevronBigDown";
import { TextFieldProps } from "./IconField.types";
import { useStyles, useInputStyles } from "./IconFieldStyles";
import TextFieldBase from "../TextFieldBase";

const IconField = React.forwardRef(function TextField(
  props: TextFieldProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const {
    getIcon,
    InputProps: InputPropsProp,
    inputProps,
    className,
    ...other
  } = props;

  const inputClasses = useInputStyles(InputPropsProp);

  const classes = useStyles();

  const InputProps = React.useMemo(() => {
    const value = inputProps?.value;
    let icon = getIcon && value ? getIcon(value) : undefined;
    if (!icon) {
      icon = <ArrowDownCircleIcon />;
    }
    let startAdornment;
    if (React.isValidElement(icon)) {
      startAdornment = icon
        ? React.cloneElement(
            icon as React.ReactElement<{ className?: string }>,
            {
              className: classes.icon,
            }
          )
        : undefined;
    }
    return {
      ...InputPropsProp,
      classes: inputClasses,
      startAdornment,
    };
  }, [getIcon, inputProps?.value, classes.icon, InputPropsProp, inputClasses]);

  return (
    <TextFieldBase
      {...other}
      className={clsx(className, classes.iconInput)}
      InputProps={InputProps}
      inputProps={inputProps}
      ref={ref}
    />
  );
});

export default IconField;
